import React from "react";
import { Alert, Link as MuiLink, Typography } from "@mui/material";
import { pricingAllForPlans_pricingAll as Pricing } from "types/gql-types";

type PlanPricingOption = { value: string; label: string };

type PricingConfig = Pick<
Pricing,
| "id"
| "minimumPrice"
| "unitThreshold"
| "monthlyPricePerUnit"
| "annualDiscountPercent"
| "pricingType"
>;

/** Formats pricing configurations into select options shared by the plan create/update forms. */
export const formatPlanPricingOptions = (
  pricing: PricingConfig[] | undefined,
): PlanPricingOption[] =>
  (pricing ?? []).map((p) => {
    const base = `${p.pricingType?.name || "Unknown"} - $${p.minimumPrice || "0"}`;
    const threshold = p.unitThreshold ? ` (${p.unitThreshold} units)` : "";
    const perUnit = p.monthlyPricePerUnit && ` - $${p.monthlyPricePerUnit}/unit` || "";
    const discount = p.annualDiscountPercent ? ` - ${p.annualDiscountPercent}% discount` : "";
    return { value: p.id, label: `${base}${threshold}${perUnit}${discount}` };
  });

/** Shown on plan create/update when no pricing configurations exist yet. */
export const NoPricingWarning: React.FC = () => (
  <Alert severity="warning" sx={{ mb: 2 }}>
    <Typography component="span" fontWeight={700}>
      No pricing configurations available.
    </Typography>{" "}
    You need to create pricing configurations before creating plans.{" "}
    <MuiLink href="/dash/admin/pricing/new">Create pricing configuration</MuiLink>
  </Alert>
);
